import PaySuiteMfePage from '@/components/paysuite/PaySuiteMfePage';

const MFE_INSTANCE_ID = '368f9405-3b41-4041-b9e7-d9a250a138e3';

export default function PaymentOnboardingPage() {
  return (
    <PaySuiteMfePage
      title="Payment Onboarding"
      description="Complete your payment setup to start accepting payments"
      componentName="onboarding"
      instanceId={MFE_INSTANCE_ID}
    />
  );
}
